import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 81D1F53A-2A63-4C9A-9CA9-547E68BB1329
 * name size-l
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-l.svg
 * tags
 */
export const SizeLIcon = createSvgIcon(<><path d="M9 7V17H15V15H11V7H9Z" /></>, 'SizeLIcon');
export default SizeLIcon